import { render, staticRenderFns } from "./articleInfo.vue?vue&type=template&id=014ac17f&scoped=true"
import script from "./articleInfo.vue?vue&type=script&lang=js"
export * from "./articleInfo.vue?vue&type=script&lang=js"
import style0 from "./articleInfo.vue?vue&type=style&index=0&id=014ac17f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014ac17f",
  null
  
)

export default component.exports